export const TOGGLE_GROUP_TAG_NAME = "toggle-group" as const;

export const TOGGLE_GROUP_ITEM_TAG_NAME = "toggle-group-item" as const;

export const TOGGLE_GROUP_VARIANTS = ["solid", "outline", "ghost"] as const;
